(() => {
  const initialize = (module) => {
    const element = module.element;
    const button = element.querySelector('.button-nav__toggle');
    const list = element.querySelector('.button-nav__links');

    // Collapsed by default
    list.classList.toggle('button-nav__links--collapsed');

    const toggleMenu = () => {
      list.classList.toggle('button-nav__links--collapsed');
      button.classList.toggle('button-nav__toggle--expanded');
    };

    if (button) {
      button.addEventListener('click', toggleMenu);
    }
  };

  const buttonNav = stp.setup('button-nav');
  buttonNav.map(initialize);
})();
